var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24.71mm",
    height: "53.975mm",
    viewBox: "0 0 24.71 53.975",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 792h612v-792h-612z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.6044e-6 -243.02)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.57606 0 0 -.57606 -285.09 600.57)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(514.07 613.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c1.497-4.424 3.022-8.751 4.375-13.131 0.199-0.644-0.427-1.544-0.671-2.326-0.69 0.273-1.33 0.661-1.892 1.145-0.446 0.619-0.716 1.345-0.786 2.104-0.684 5.428-3.187 10.057-6.153 14.52-0.533 0.848-0.819 1.83-0.825 2.833 0 1.559 0.921 2.112 2.543 1.863 3.377-0.519 6.787-0.819 10.171-1.304 2.246-0.283 4.47-0.717 6.659-1.298 0.602-0.172 0.928-1.317 1.381-2.015-0.756-0.203-1.784-0.828-2.225-0.542-3.779 2.442-7.906 1.006-12.392 1.32 4.16-2.819 8.039-5.243 11.694-7.968 7.338-5.213 11.733-13.626 11.819-22.627 0.302-8.189-2.617-15.456-5.438-22.83-2.595-7.246-6.646-13.884-11.904-19.504-6.056-6.237-12.277-12.363-20.446-15.918-1.071-0.494-2.214-0.815-3.385-0.952-0.532-0.047-1.131 0.677-1.7 1.051 0.298 0.524 0.704 0.979 1.191 1.336 13.29 5.225 22.993 14.644 30.024 26.719 3.007 5.163 4.681 11.123 6.772 16.79 0.91 2.431 1.542 4.956 1.889 7.528 1.248 9.731-1.606 21.394-12.04 27.407-3.053 1.759-5.874 3.918-8.661 5.799"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageArrow);
export default __webpack_public_path__ + "static/media/image_arrow.879ee5187fce531124938ce6156413c1.svg";
export { ForwardRef as ReactComponent };